import React, { useEffect, useMemo, useRef, useState } from "react";
import { Dimensions, Image, View, Platform, ActivityIndicator } from "react-native";
import { SCREEN_SIZE } from '@voltmoney/types';
import BoilerPlate from "../boilerPlate/BoilerPlate";
import CustomHeader from "../../customHeader/CustomHeader";
import { WebView } from 'react-native-webview';
import { DOCUMENT_TYPE } from "./types";
const ASESViewSampleDocument = ({ height, triggerAction, goBackAction, documentURL, documentType, fileName }) => {
    const [urlLoaded, setUrlLoaded] = useState(false);
    const webViewRef = useRef(null);
    const [imageLoaded, setImageLoaded] = useState(false);
    const imageURL = (type) => {
        let imageUrl;
        switch (type) {
            case DOCUMENT_TYPE.AADHAAR_CARD:
                imageUrl = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/sample_aadhar.png";
                break;
            case DOCUMENT_TYPE.PAN_CARD:
                imageUrl = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/sample_pan_doc.png";
                break;
            case DOCUMENT_TYPE.CO_BORROWER_FORM:
                imageUrl = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/co_borrower_form_sample.pdf";
                break;
            case DOCUMENT_TYPE.ADDENDUM:
                imageUrl = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/addendum_sample_doc.pdf";
                break;
            case DOCUMENT_TYPE.ECS_MANDATE:
                imageUrl = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/sample_mandate_form.png";
        }
        return imageUrl;
    };
    const getPageTitle = (type) => {
        let title;
        switch (type) {
            case DOCUMENT_TYPE.PAN_CARD:
                title = "Sample PAN card";
                break;
            case DOCUMENT_TYPE.AADHAAR_CARD:
                title = "Sample aadhaar card";
                break;
            case DOCUMENT_TYPE.ADDENDUM:
                title = "Sample addendum form";
                break;
            case DOCUMENT_TYPE.CO_BORROWER_FORM:
                title = "Sample co-applicant form";
                break;
            case DOCUMENT_TYPE.ECS_MANDATE:
                title = "Sample mandate form";
                break;
        }
        return title;
    };
    const webView = (url) => {
        return (React.createElement(WebView, { source: { uri: url }, style: { width: '100%', height: height - 130 }, onLoad: () => {
                setUrlLoaded(true);
            }, automaticallyAdjustContentInsets: false, javaScriptEnabled: true, startInLoadingState: true, useWebKit: true, originWhitelist: ['*'], allowsInlineMediaPlayback: true, scrollEnabled: true, mediaPlaybackRequiresUserAction: false, javaScriptEnabledAndroid: true, showsHorizontalScrollIndicator: false, nestedScrollEnabled: Platform.OS !== "web", ref: webViewRef, scalesPageToFit: true, setBuiltInZoomControls: false }));
    };
    useEffect(() => {
    });
    const headerView = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(CustomHeader, { title: fileName ? fileName : getPageTitle(documentType), triggerAction: triggerAction, hideNeedHelp: true, goBackAction: goBackAction })));
    };
    const renderImage = useMemo(() => {
        return (React.createElement(View, null,
            !imageLoaded && (React.createElement(ActivityIndicator, { size: "large", color: "#1434CB", style: { justifyContent: 'center', alignSelf: 'center', height: height - 120, zIndex: 1, position: 'absolute', left: 50, right: 50 } })),
            React.createElement(Image, { source: { uri: imageURL(documentType) }, style: { width: '100%', height: height - 120, opacity: !imageLoaded && 0.5 }, onLoad: () => {
                    setImageLoaded(true);
                }, resizeMode: 'contain' })));
    }, [imageLoaded]);
    const bodyView = () => {
        return (React.createElement(View, { style: { marginTop: 16, paddingHorizontal: 16 } }, !documentURL ? documentType === DOCUMENT_TYPE.ADDENDUM || documentType === DOCUMENT_TYPE.CO_BORROWER_FORM ? webView(imageURL(documentType)) :
            renderImage :
            webView(documentURL)));
    };
    return (React.createElement(View, { style: { marginHorizontal: -16 } },
        React.createElement(BoilerPlate, { height: height - 16, headerChild: React.createElement(React.Fragment, null, headerView()) }, React.createElement(React.Fragment, null, bodyView()))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
export default (ASESViewSampleDocument);
